export default __webpack_public_path__ + "static/media/1361.0f4a95d9.png";